module.exports = __webpack_public_path__ + "img/redes-icono-linkedin.82d7ef60.svg";